const GridSmallIcon = props => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="1"
      y="1"
      width="4"
      height="4"
      rx="1.5"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="1"
      y="7"
      width="4"
      height="4"
      rx="1.5"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="1"
      y="13"
      width="4"
      height="4"
      rx="1.5"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="7"
      y="1"
      width="4"
      height="4"
      rx="1.5"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="7"
      y="7"
      width="4"
      height="4"
      rx="1.5"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="7"
      y="13"
      width="4"
      height="4"
      rx="1.5"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="13"
      y="1"
      width="4"
      height="4"
      rx="1.5"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="13"
      y="7"
      width="4"
      height="4"
      rx="1.5"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="13"
      y="13"
      width="4"
      height="4"
      rx="1.5"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export { GridSmallIcon };
